package ai.beakman.undercover.i18n

/**
 * Idiomas suportados pela UI e pelos dados de jogo.
 * Default/fallback = [EN] (para idioma de sistema desconhecido).
 */
enum class Language(val code: String, val displayName: String) {
    EN("en", "English"),
    PT("pt", "Português"),
    ES("es", "Español");

    companion object {
        /**
         * Resolve um código de idioma (BCP-47 ou ISO simples, ex.: "pt-BR", "es_MX")
         * para um [Language]. Usa o prefixo antes de `-`/`_`. Default = [EN].
         */
        fun fromCode(code: String?): Language {
            if (code.isNullOrBlank()) return EN
            val prefix = code.lowercase().substringBefore('-').substringBefore('_')
            return entries.firstOrNull { it.code == prefix } ?: EN
        }
    }
}
